import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.quiz.result');
import { OnInit, OnDestroy } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-quiz-result',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.quiz.result/view.scss */
:host {
  display: block;
  height: 100%;
  overflow-y: auto;
}`],
})
export class PageQuizResultComponent implements OnInit, OnDestroy {
    public exam: any = {};
    public result: any = {};
    public details: any[] = [];
    public chapterNames: any = {};

    public loading: boolean = true;
    public tab: string = 'overview';
    public showDetail: boolean = false;
    public selectedQuestion: any = null;
    public addingWrongNotes: boolean = false;

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.loadResult();
        await this.service.render();
    }

    ngOnDestroy() { }

    public async loadResult() {
        this.loading = true;
        await this.service.render();

        const examId = WizRoute.segment.id;
        const res = await wiz.call("load", { exam_id: examId });
        if (res.code === 200) {
            this.exam = res.data.exam || {};
            this.result = res.data.result || {};
            this.details = (res.data.details || []).sort((a: any, b: any) => a.order_num - b.order_num);
            this.chapterNames = res.data.chapter_names || {};
        }

        this.loading = false;
        await this.service.render();
    }

    public get isQualifyPast(): boolean {
        return this.exam.subject_id === 'qualify_past';
    }

    public get scorePercent(): number {
        return this.result.total_score || 0;
    }

    public get gradeText(): string {
        if (this.isQualifyPast) {
            return this.result.grade === 1 ? '합격' : '불합격';
        }
        const g = this.result.grade;
        if (!g || g === 0) return '-';
        return `${g}등급`;
    }

    public get gradeColor(): string {
        if (this.isQualifyPast) {
            return this.result.grade === 1 ? 'text-green-600' : 'text-red-600';
        }
        const g = this.result.grade || 0;
        if (g <= 2) return 'text-blue-600';
        if (g <= 4) return 'text-green-600';
        if (g <= 6) return 'text-yellow-600';
        return 'text-red-600';
    }

    public get correctCount(): number {
        return this.result.correct_count || 0;
    }

    public get wrongCount(): number {
        return this.result.wrong_count || 0;
    }

    public get unansweredCount(): number {
        return this.result.unanswered_count || 0;
    }

    public get totalCount(): number {
        return this.result.total_count || 0;
    }

    public formatTime(seconds: number): string {
        if (!seconds) return '0분 0초';
        const m = Math.floor(seconds / 60);
        const s = seconds % 60;
        if (m > 0) return `${m}분 ${s}초`;
        return `${s}초`;
    }

    public get elapsedTimeText(): string {
        return this.formatTime(this.result.elapsed_time || 0);
    }

    public get chapterAnalysis(): any[] {
        return this.result.chapter_analysis || [];
    }

    public get difficultyAnalysis(): any[] {
        const arr = this.result.difficulty_analysis || [];
        return arr.sort((a: any, b: any) => a.difficulty - b.difficulty);
    }

    public getChapterName(chapterId: string): string {
        return this.chapterNames[chapterId] || chapterId;
    }

    public getDifficultyLabel(d: number): string {
        const labels: any = { 1: '매우 쉬움', 2: '쉬움', 3: '보통', 4: '어려움', 5: '매우 어려움' };
        return labels[d] || `난이도 ${d}`;
    }

    public getTypeLabel(t: string): string {
        const labels: any = {
            'multiple_choice': '5지선다',
            'ox': 'OX',
            'ordering': '순서배열',
            'matching': '연결하기',
            'short_answer': '단답형'
        };
        return labels[t] || t;
    }

    public setTab(t: string) {
        this.tab = t;
        this.service.render();
    }

    public viewQuestion(q: any) {
        this.selectedQuestion = q;
        this.showDetail = true;
        this.service.render();
    }

    public closeDetail() {
        this.showDetail = false;
        this.selectedQuestion = null;
        this.service.render();
    }

    public isCorrect(q: any): boolean {
        return q.is_correct === 1;
    }

    public isWrong(q: any): boolean {
        return q.is_correct === 0;
    }

    public isUnanswered(q: any): boolean {
        return q.is_correct === -1 || q.user_answer === '' || q.user_answer == null;
    }

    public getAnswerDisplay(q: any): string {
        if (!q.user_answer) return '미응답';
        if (q.question_type === 'multiple_choice') {
            const idx = parseInt(q.user_answer);
            if (!isNaN(idx) && q.options && q.options[idx]) return q.options[idx];
            return q.user_answer;
        }
        if (q.question_type === 'ox') return q.user_answer === 'O' ? 'O' : 'X';
        return q.user_answer;
    }

    public getCorrectDisplay(q: any): string {
        if (!q.answer) return '-';
        if (q.question_type === 'multiple_choice') {
            const idx = parseInt(q.answer);
            if (!isNaN(idx) && q.options && q.options[idx]) return q.options[idx];
            return q.answer;
        }
        if (q.question_type === 'ox') return q.answer === 'O' ? 'O' : 'X';
        return q.answer;
    }

    // --- 이미지 문제 헬퍼 ---
    public isImageContent(content: string): boolean {
        return content?.startsWith('[IMG]') || false;
    }

    public getImageUrl(content: string): string {
        if (!this.isImageContent(content)) return '';
        const path = content.substring(5);
        return wiz.app('page.quiz.play').url('question_image') + '?path=' + encodeURIComponent(path);
    }

    public async addToWrongNotes() {
        if (this.wrongCount === 0) {
            await this.service.modal.show({ title: '알림', message: '틀린 문제가 없습니다!', status: 'warning', action: '확인', actionBtn: 'primary', cancel: false });
            return;
        }

        const examId = WizRoute.segment.id;
        this.addingWrongNotes = true;
        await this.service.render();

        const res = await wiz.call("add_wrong_notes", { exam_id: examId });
        this.addingWrongNotes = false;

        if (res.code === 200) {
            await this.service.modal.show({ title: '완료', message: '틀린 문제가 오답노트에 추가되었습니다.', status: 'success', action: '확인', actionBtn: 'primary', cancel: false });
        } else {
            await this.service.modal.show({ title: '오류', message: res.data?.message || '추가에 실패했습니다.', status: 'error', action: '확인', actionBtn: 'primary', cancel: false });
        }
        await this.service.render();
    }

    public goBack() {
        this.service.href('/dashboard');
    }

    public retryQuiz() {
        this.service.href('/quiz/setting');
    }

    public goWrongNote() {
        this.service.href('/wrong-note');
    }
}

export default PageQuizResultComponent;